import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type OperatorSessionSwitchStatus = 'RECEIVED' | 'SUCCESS' | 'FAILED';

export interface OperatorSessionSwitchEntry {
  status: OperatorSessionSwitchStatus;
  sessionId?: string;
  reason?: string;
  updatedAt: number;
}

export interface OperatorSessionSwitchStateType {
  byOperatorId: Record<string, OperatorSessionSwitchEntry>;
}

const initialState: OperatorSessionSwitchStateType = {
  byOperatorId: {},
};

export const operatorSessionSwitchSlice = createSlice({
  name: 'operatorSessionSwitch',
  initialState,
  reducers: {
    setOperatorSessionSwitchStatus(
      state,
      action: PayloadAction<{
        operatorId: string;
        status: OperatorSessionSwitchStatus;
        sessionId?: string;
        reason?: string;
      }>
    ) {
      const { operatorId, status, sessionId, reason } = action.payload;
      state.byOperatorId[operatorId] = {
        status,
        sessionId,
        reason,
        updatedAt: Date.now(),
      };
    },
    clearOperatorSessionSwitchStatus(state, action: PayloadAction<string>) {
      const { [action.payload]: _removed, ...rest } = state.byOperatorId;
      state.byOperatorId = rest;
    },
  },
});

export const {
  setOperatorSessionSwitchStatus,
  clearOperatorSessionSwitchStatus,
} = operatorSessionSwitchSlice.actions;

export default operatorSessionSwitchSlice.reducer;
